
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getThemeClasses } from "./craft-generator/CraftGeneratorTheme";
import SuppliesList from "./craft-generator/SuppliesList";
import AddCustomSupply from "./craft-generator/AddCustomSupply";
import GeneratorActions from "./craft-generator/GeneratorActions";
import CraftIdeasResult from "./craft-generator/CraftIdeasResult";
import { useGeneratorLogic } from "./craft-generator/useGeneratorLogic";
import { CraftGeneratorProps } from "./craft-generator/types";

const CraftGenerator: React.FC<CraftGeneratorProps> = ({ 
  theme = "default", 
  instanceId = "default",
  postId
}) => {
  const {
    supplies,
    craftIdeas,
    usageCount,
    defaultSupplyIds,
    toggleSupply,
    addCustomSupply,
    removeSupply,
    generateIdeas,
    resetGenerator
  } = useGeneratorLogic(instanceId, postId);

  const themeClasses = getThemeClasses(theme);

  return (
    <Card className={`w-full my-6 ${themeClasses.cardClass}`}>
      <CardHeader>
        <CardTitle className={themeClasses.titleClass}>
          Holiday Elf Craft Generator
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium mb-2">Select Your Craft Supplies:</h3>
            <SuppliesList 
              supplies={supplies} 
              onToggleSupply={toggleSupply} 
              onRemoveSupply={removeSupply}
              defaultSupplyIds={defaultSupplyIds}
            />
          </div>

          <AddCustomSupply 
            onAddSupply={addCustomSupply} 
            themeClasses={themeClasses} 
          />

          <GeneratorActions 
            onGenerateIdeas={generateIdeas} 
            onReset={resetGenerator} 
            hasSelectedSupplies={supplies.some(s => s.checked)}
            themeClasses={themeClasses} 
          />

          <CraftIdeasResult 
            craftIdeas={craftIdeas} 
            themeClasses={themeClasses} 
          />
          
          <div className="text-xs text-gray-500 text-right">
            Tool usage count: {usageCount}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CraftGenerator;
